<template>
<v-container class="pa-0">
  <SmallTableCard
      :title="totalDisplayText"
      :items="formattedCoverages"
      two-column
      :headers="['Fee']"
      :fields="[ { name: 'name', type: ''}, { name: 'premium', type: 'currency'} ]" />
</v-container>
</template>

<style scoped>
</style>

<script>
import { mapActions } from 'vuex';
import displayFormatterService from '@/services/shared/displayFormatterService.js';
import SmallTableCard from '@/components/Shared/SmallTableCard.vue';

export default {
  name: 'Fees',
  components: { SmallTableCard },
  props: {
    coverages: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      loading: true,
      totalPremium: 0,
      formattedCoverages: [],

      lobColors: [
        'blue6',
        'blue5'
      ]
    };
  },
  computed: {
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    noDataText: function () {
      return this.error ? 'An error occurred fetching coverages' : 'This line of business has no coverages';
    },
    formattedTotalPremium: function () {
      return displayFormatterService.formatCurrency(this.totalPremium);
    },
    totalDisplayText: function () {
      return 'Total Fees: ' + this.formattedTotalPremium;
    }
  },
  watch: {
    coverages: function (data) {
      this.formattedCoverages = this.formatCoverages(this.coverages.coverages);
    }
  },
  methods: {
    ...mapActions(['setError']),
    formatCoverages: function (coverages) {
      coverages.forEach(x => {
        this.totalPremium += isNaN(x.premium) ? 0 : x.premium;
      });

      coverages.sort((a, b) => a.displayOrder - b.displayOrder);

      return coverages;
    }
  }
};
</script>
